export default () => ({
  tooltips: []
})
